export const props = {
  visible: {
    type: Boolean,
    default: false,
  },
  zIndex: {
    type: Number,
    default: 2000,
  },
  overlayClass: {
    type: String,
    default: '',
  },
  lockScroll: {
    type: Boolean,
    default: true,
  },
  duration: {
    type: [Number, String],
    default: 0.3,
  },
};
